import { render, staticRenderFns } from "./GroupTypeForm.vue?vue&type=template&id=db5b5b0e&"
import script from "./GroupTypeForm.vue?vue&type=script&lang=js&"
export * from "./GroupTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports